// Generic sorters for the app data layer. Per spec/build-plan.md P-024
// row + the project's "extract on third use" convention.
//
// **`sortByUpdatedDesc`** lifts the verbatim helper that landed in three
// screen files at P-024 (home + template-list + email-list). ISO 8601
// strings sort lexicographically equivalently to chronologically; the
// comparator stays inside the string domain via `localeCompare`. The
// helper produces a new array (does not mutate input).

export function sortByUpdatedDesc<T extends { updatedAt: string }>(items: readonly T[]): T[] {
  return [...items].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
}
